<div class="main-container">
  <div class="display-single-number-picker" text-center width-15>
    @if (drawOption !== undefined && drawOption !== null) {
      <single-number-picker
        [pick]="nonSelectedPicked"
        [type]="drawOption.shapeType"
        [readonly]="true"
        [isDisplayLine]="false"
        [nonSelectedStrokeColor]="drawOption.nonSelectedStrokeColor"
        [nonSelectedFillColor]="drawOption.nonSelectedFillColor"
        [nonSelectedTextColor]="drawOption.nonSelectedTextColor"
        [selectedStrokeColor]="drawOption.selectedStrokeColor"
        [selectedFillColor]="drawOption.selectedFillColor"
        [selectedTextColor]="drawOption.selectedTextColor"
        [placeholderFillColor]="drawOption.placeholderFillColor"
        [placeholderStrokeColor]="drawOption.placeholderStrokeColor"
        [placeholderTextColor]="drawOption.placeholderTextColor"
        [selectionPlaceholderFillColor]="drawOption.selectionPlaceholderFillColor"
        [selectionPlaceholderStrokeColor]="drawOption.selectionPlaceholderStrokeColor"
        [selectionPlaceholderTextColor]="drawOption.selectionPlaceholderTextColor"
        [optionType]="drawOption.optionType"></single-number-picker>
    }
  </div>

  <div class="display-single-number-picker" text-center width-15>
    @if (drawOption !== undefined && drawOption !== null) {
      <single-number-picker
        [pick]="selectedPicked"
        [type]="drawOption.shapeType"
        [readonly]="true"
        [isDisplayLine]="true"
        [nonSelectedStrokeColor]="drawOption.nonSelectedStrokeColor"
        [nonSelectedFillColor]="drawOption.nonSelectedFillColor"
        [nonSelectedTextColor]="drawOption.nonSelectedTextColor"
        [selectedStrokeColor]="drawOption.selectedStrokeColor"
        [selectedFillColor]="drawOption.selectedFillColor"
        [selectedTextColor]="drawOption.selectedTextColor"
        [placeholderFillColor]="drawOption.placeholderFillColor"
        [placeholderStrokeColor]="drawOption.placeholderStrokeColor"
        [placeholderTextColor]="drawOption.placeholderTextColor"
        [selectionPlaceholderFillColor]="drawOption.selectionPlaceholderFillColor"
        [selectionPlaceholderStrokeColor]="drawOption.selectionPlaceholderStrokeColor"
        [selectionPlaceholderTextColor]="drawOption.selectionPlaceholderTextColor"
        [optionType]="drawOption.optionType"></single-number-picker>
    }
  </div>

  <div class="display-single-number-picker" text-center width-15>
    @if (drawOption !== undefined && drawOption !== null) {
      <single-number-picker
        [pick]="placeholderPicked"
        [type]="drawOption.shapeType"
        [readonly]="true"
        [isDisplayLine]="true"
        [nonSelectedStrokeColor]="drawOption.nonSelectedStrokeColor"
        [nonSelectedFillColor]="drawOption.nonSelectedFillColor"
        [nonSelectedTextColor]="drawOption.nonSelectedTextColor"
        [selectedStrokeColor]="drawOption.selectedStrokeColor"
        [selectedFillColor]="drawOption.selectedFillColor"
        [selectedTextColor]="drawOption.selectedTextColor"
        [placeholderFillColor]="drawOption.placeholderFillColor"
        [placeholderStrokeColor]="drawOption.placeholderStrokeColor"
        [placeholderTextColor]="drawOption.placeholderTextColor"
        [selectionPlaceholderFillColor]="drawOption.selectionPlaceholderFillColor"
        [selectionPlaceholderStrokeColor]="drawOption.selectionPlaceholderStrokeColor"
        [selectionPlaceholderTextColor]="drawOption.selectionPlaceholderTextColor"
        [optionType]="drawOption.optionType"></single-number-picker>
    }
  </div>

  <div class="display-single-number-picker" text-center width-15>
    @if (drawOption !== undefined && drawOption !== null) {
      <single-number-picker
        [pick]="selectionPlaceholderPicked"
        [type]="drawOption.shapeType"
        [readonly]="true"
        [isDisplayLine]="true"
        [nonSelectedStrokeColor]="drawOption.nonSelectedStrokeColor"
        [nonSelectedFillColor]="drawOption.nonSelectedFillColor"
        [nonSelectedTextColor]="drawOption.nonSelectedTextColor"
        [selectedStrokeColor]="drawOption.selectedStrokeColor"
        [selectedFillColor]="drawOption.selectedFillColor"
        [selectedTextColor]="drawOption.selectedTextColor"
        [placeholderFillColor]="drawOption.placeholderFillColor"
        [placeholderStrokeColor]="drawOption.placeholderStrokeColor"
        [placeholderTextColor]="drawOption.placeholderTextColor"
        [selectionPlaceholderFillColor]="drawOption.selectionPlaceholderFillColor"
        [selectionPlaceholderStrokeColor]="drawOption.selectionPlaceholderStrokeColor"
        [selectionPlaceholderTextColor]="drawOption.selectionPlaceholderTextColor"
        [optionType]="drawOption.optionType"></single-number-picker>
    }
  </div>
</div>
<div class="shape-header-container">
  <div class="shape-header">NS</div>
  <div class="shape-header">S</div>
  <div class="shape-header">P</div>
  <div class="shape-header">SP</div>
</div>
